import React from 'react'
import '../App.css'
import Header from "../Components/Header.js"
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import { useNavigate } from 'react-router-dom'

export default function Book() {

  let navigate = useNavigate()  

  const myStyle = {
    backgroundImage:
        "url('/book.png')",
    height: "100vh",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "relative",
  }


  return (
    <div style={myStyle}>
      <Header />
      <div className='allPage' onClick={() => navigate('/')}></div>
      <div className="floating-container">
        <a href="https://www.amazon.it/s?k=wild+dolomiti+losso" rel="noreferrer" target="_blank" className="btn btn-warning buttonAmazon">
          Acquista su Amazon
        </a>        
      </div>
   </div>
  )
}